import { Text } from "@flat-ui";
import { Box } from "@mui/material";
import { sectionPlaceholderStyles } from "@components/analytics/in-house/in-house-analytics-styles";

/** Placeholder for the data table component (ST-4144) */
export function AnalyticsTable(): JSX.Element {
  return (
    <Box
      data-testid="analytics-table"
      sx={{
        ...sectionPlaceholderStyles,
        height: "18rem",
      }}
    >
      <Text variant="bodyM">Table</Text>
    </Box>
  );
}
